import { useMutation, useQueryClient } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { ratingSettingsService } from 'src/services/rating-settings.service'

export const useRemoveRatingSetting = () => {
  const queryClient = useQueryClient()

  return useMutation((ids: string[]) => ratingSettingsService.removeRatingSettings(ids), {
    onSuccess: async (data) => {
      if (data) {
        queryClient.invalidateQueries(QUERY_KEYS.RATING_SETTINGS)
      }
    },
  })
}
